import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import type {
  HtmlComponentDefinition,
  HtmlComponentProps,
  HtmlComponentMapperProps,
} from '../HtmlComponent.types';
import { props as viewerPropsMapper } from './HtmlComponent.mapper';

const SANDBOX =
  'allow-same-origin allow-forms allow-popups allow-modals allow-scripts allow-pointer-lock';

const props = composeMapper<
  PreviewWrapperProps<HtmlComponentMapperProps>,
  HtmlComponentDefinition,
  HtmlComponentProps
>()(
  viewerPropsMapper,
  { add: ['shouldResetComponent'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { shouldResetComponent } = deps;

    return {
      ...viewerProps,
      sandbox: viewerProps.sandbox ?? SANDBOX,
      previewWrapperProps: {
        shouldResetComponent,
      },
    };
  },
);

export default createComponentPreviewMapperModel({ props });
